import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { NavbarDashbord } from './navbarDashbord';
import { Wind, FolderKanban, Users, ShoppingCart, TrendingUp, CheckCircle, Clock, PlusCircle, LayoutGrid, MessageSquare, History, Trash2, ExternalLink, User, Calendar } from 'lucide-react';
import { getDataHistories, deleteHistory } from './action';
import '../styles/admin.css';
import { useEffect } from 'react';

export function DashbordPage() {
    const dispatch = useDispatch();
    const listC = useSelector(state => state.listC) || [];
    const listP = useSelector(state => state.listP) || [];
    const comptes = useSelector(state => state.comptes) || [];
    const commandes = useSelector(state => state.commandes) || [];
    const histories = useSelector(state => state.histories) || [];
    const state = { listC, listP, comptes, commandes, histories };

    useEffect(() => {
        dispatch(getDataHistories());
    }, [dispatch]);

    const handleDeleteOne = (id) => {
        dispatch(deleteHistory(id));
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return 'Date inconnue';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return 'Date inconnue';
        return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
    };

    const formatTime = (dateStr) => {
        if (!dateStr) return '--:--';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return '--:--';
        return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    };


    const stats = [
        { label: 'Climatiseurs', value: listC.length.toString(), icon: <Wind size={24} />, color: '#000033' },
        { label: 'Projets', value: listP.length.toString(), icon: <FolderKanban size={24} />, color: '#700000' },
        { label: 'Comptes Actifs', value: comptes.filter(c => c.status === 'Actif').length.toString(), icon: <Users size={24} />, color: '#2e7d32' },
        { label: 'Commandes Totales', value: commandes.length.toString(), icon: <ShoppingCart size={24} />, color: '#f59e0b' },
    ];

    const orderStats = [
        { label: 'Livrées', value: commandes.filter(c => c.statut?.toLowerCase() === 'livrée').length.toString(), icon: <CheckCircle size={20} />, color: 'var(--admin-success)', link: '/pageCommandes?status=livrée' },
        { label: 'En cours', value: commandes.filter(c => c.statut?.toLowerCase() === 'en cours').length.toString(), icon: <TrendingUp size={20} />, color: 'var(--admin-warning)', link: '/pageCommandes?status=en%20cours' },
        { label: 'En attente', value: commandes.filter(c => c.statut?.toLowerCase() === 'en attente').length.toString(), icon: <Clock size={20} />, color: 'var(--admin-danger)', link: '/pageCommandes?status=en%20attente' },
    ];

    const activityData = [
        { label: 'Visites', value: 85, color: '#000033' },
        { label: 'Commandes', value: Math.min(100, (commandes.length * 10)), color: '#700000' },
        { label: 'Avis (+)', value: Math.min(100, (listC.reduce((acc, c) => acc + (c.commantaires ? c.commantaires.length : 0), 0) * 5) || 20), color: '#2e7d32' },
        { label: 'Projets', value: Math.min(100, (listP.length * 8)), color: '#f59e0b' },
        { label: 'Livrées', value: Math.min(100, (commandes.filter(c => c.statut?.toLowerCase() === 'livrée').length * 15)), color: '#10b981' },
    ];

    return (
        <div className="admin-layout">
            <NavbarDashbord />
            <main className="admin-main-content">
                <header className="admin-header">
                    <div className="admin-title-group">
                        <h1>Command Center</h1>
                        <p>Pilotage intelligent de Jamas Lens.</p>
                    </div>
                </header>

                {/* Top Row: Stats + Actions */}
                <div className="dashboard-top-row">
                    <div className="dashboard-stats-grid-mini">
                        {stats.map((stat, idx) => (
                            <div key={idx} className="dashboard-mini-card">
                                <div className="mini-card-icon" style={{ backgroundColor: `${stat.color}10`, color: stat.color }}>
                                    {stat.icon}
                                </div>
                                <div className="mini-card-info">
                                    <span className="mini-card-value">{stat.value}</span>
                                    <span className="mini-card-label">{stat.label}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    <div className="dashboard-quick-actions">
                        <Link to="/admin-climatisseur/add" title="Nouveau Climatiseur" className="quick-action-btn primary">
                            <PlusCircle size={18} />
                            <span>Nouveau Climatiseur</span>
                        </Link>
                        <Link to="/admin-projet/add" title="Nouveau Projet" className="quick-action-btn secondary">
                            <LayoutGrid size={18} />
                            <span>Nouveau Projet</span>
                        </Link>
                        <Link to="/pageCommentaires" title="Gérer Commentaires" className="quick-action-btn accent">
                            <MessageSquare size={18} />
                            <span>Gérer Commentaires</span>
                        </Link>
                    </div>
                </div>

                <div className="dashboard-grid-secondary">
                    <div className="admin-chart-section">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                            <h2 style={{ fontSize: '1.1rem', color: 'var(--admin-primary)', fontWeight: '800', margin: 0 }}>Analyse d'Activité</h2>
                            <span style={{ fontSize: '0.65rem', color: 'var(--admin-success)', fontWeight: '700', backgroundColor: 'rgba(16, 185, 129, 0.1)', padding: '4px 10px', borderRadius: '20px' }}>Sync Dynamique</span>
                        </div>
                        <div className="chart-wrapper">
                            {activityData.map((data, i) => (
                                <div key={i} className="bar-container">
                                    <div 
                                        className="bar" 
                                        style={{ 
                                            height: `${data.value}%`,
                                            background: `linear-gradient(to top, ${data.color}, ${data.color}99)`,
                                            width: '60%',
                                            borderRadius: '4px 4px 0 0'
                                        }}
                                        title={`${data.value}% ${data.label}`}
                                    ></div>
                                    <span style={{ fontSize: '0.6rem', fontWeight: '800', color: 'var(--admin-text-muted)', marginTop: '8px', whiteSpace: 'nowrap' }}>{data.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="admin-status-box">
                        <h2 style={{ fontSize: '1.1rem', color: 'var(--admin-primary)', fontWeight: '800', marginBottom: '20px' }}>Flux des Commandes</h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {orderStats.map((item, idx) => (
                                <Link 
                                    to={item.link} 
                                    key={idx} 
                                    className="status-row-item"
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div className="status-icon-box" style={{ backgroundColor: `${item.color}10`, color: item.color }}>
                                            {item.icon}
                                        </div>
                                        <div>
                                            <p style={{ margin: 0, fontWeight: '700', fontSize: '0.8rem' }}>{item.label}</p>
                                            <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--admin-text-muted)' }}>Mise à jour en direct</p>
                                        </div>
                                    </div>
                                    <span style={{ fontWeight: '900', fontSize: '1.1rem', color: 'var(--admin-primary)' }}>{item.value}</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="activity-feed-section" style={{ marginTop: '30px' }}>
                    <div className="activity-feed-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ fontSize: '1.1rem', color: 'var(--admin-primary)', fontWeight: '800', margin: 0 }}>Activités Récentes</h2>
                        <Link to="/pageHistorique" className="view-all-link" style={{ textDecoration: 'none', color: 'var(--admin-secondary)', fontWeight: '700', fontSize: '0.75rem', cursor: 'pointer' }}>Voir tout l'historique</Link>
                    </div>
                    <div className="feed-list">
                        {(state.histories || []).slice(0, 3).map((item, idx) => (
                                <div key={item.id || idx} className="history-item-card" style={{ 
                                    background: 'white', 
                                    padding: '20px 25px', 
                                    borderRadius: '18px', 
                                    marginBottom: '0px', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'space-between',
                                    border: '1px solid var(--admin-border)',
                                    boxShadow: 'var(--admin-shadow-sm)',
                                    position: 'relative'
                                }}>
                                    <div className="history-left-group" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        <div className="history-indicator" style={{ 
                                            width: '4px', 
                                            height: '40px', 
                                            backgroundColor: item.color || 'var(--admin-primary)',
                                            borderRadius: '10px'
                                        }}></div>
                                        
                                        <div className="history-main-info">
                                            <h4 style={{ margin: 0, fontSize: '0.95rem', fontWeight: '800', color: 'var(--admin-primary)' }}>{item.title}</h4>
                                            <div className="history-meta" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '5px', fontSize: '0.75rem', color: 'var(--admin-text-muted)' }}>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <User size={12} /> {item.user}
                                                </span>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <Calendar size={12} /> {formatDate(item.created_at)}
                                                </span>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <Clock size={12} /> {item.time || formatTime(item.created_at)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="history-right-group" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        {item.amount && (
                                            <span className="history-amount" style={{ 
                                                fontWeight: '900', 
                                                fontSize: '0.9rem', 
                                                color: 'var(--admin-secondary)',
                                                background: 'rgba(112, 0, 0, 0.05)',
                                                padding: '4px 12px',
                                                borderRadius: '10px'
                                            }}>{item.amount}</span>
                                        )}
                                        
                                        <div className="history-actions" style={{ display: 'flex', gap: '8px' }}>
                                            <button className="history-action-btn delete" onClick={() => handleDeleteOne(item.id)} title="Supprimer">
                                                <Trash2 size={16} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                        ))}
                        {(state.histories || []).length === 0 && (
                            <p style={{ textAlign: 'center', color: 'var(--admin-text-muted)', padding: '20px', fontSize: '0.8rem' }}>Aucune activité récente.</p>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}